import(/* webpackMode: "eager" */ "/app/assets/images/error-images/noMatchesAvailable.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/error-images/overview.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/error-images/statsNotAvailable.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/icon/right-icon-blue.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/icon/right-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/commonNav/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/components/customLink/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/Error/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/components/myImage/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/newsTab/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/players/playerHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/players/playerInfo/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/widgets/trendingPlayer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/revive-ads/index.tsx");
